import { render, staticRenderFns } from "./u-tooltip-outlined-rounded.vue?vue&type=template&id=62f6e5fc&scoped=true&"
import script from "./u-tooltip-outlined-rounded.vue?vue&type=script&lang=js&"
export * from "./u-tooltip-outlined-rounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f6e5fc",
  null
  
)

export default component.exports